(() => {
    "use strict";

    if (window.__KYRA_WISHLIST_V2_INITIALIZED__) {
        return;
    }

    window.__KYRA_WISHLIST_V2_INITIALIZED__ = true;

    document.documentElement.setAttribute(
        "data-kyra-wishlist-ready",
        "true"
    );

    console.info("[Kyra Wishlist] v2 funcionando (Limpieza de Emojis Activa)");

    const STORAGE_KEY = "kyra_wishlist_v1";

    const DRAWER_SELECTOR = "#KyraWishlistDrawer";
    const OPEN_SELECTOR = "[data-kyra-wishlist-open]";
    const MOBILE_OPEN_SELECTOR = "[data-kyra-wishlist-mobile-open]";
    const CLOSE_SELECTOR = "[data-kyra-wishlist-close]";
    const TOGGLE_SELECTOR = "[data-kyra-wishlist-toggle]";
    const REMOVE_SELECTOR = "[data-kyra-wishlist-remove]";

    let lastActiveElement = null;

    function getDrawer() {
        return document.querySelector(DRAWER_SELECTOR);
    }

    function escapeHtml(value = "") {
        return String(value)
            .replaceAll("&", "&amp;")
            .replaceAll("<", "&lt;")
            .replaceAll(">", "&gt;")
            .replaceAll('"', "&quot;")
            .replaceAll("'", "&#039;");
    }

    function stripHtml(value = "") {
        const temporaryElement = document.createElement("div");
        temporaryElement.innerHTML = String(value);
        return (temporaryElement.textContent || "")
            .replace(/\s+/g, " ")
            .trim();
    }

    // Función para limpiar emojis y caracteres especiales de los títulos de los productos
    function cleanProductTitle(title = "") {
        return title
            .replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '')
            .trim();
    }

    function readWishlist() {
        try {
            const savedValue = window.localStorage.getItem(STORAGE_KEY);

            if (!savedValue) {
                return [];
            }

            const parsedValue = JSON.parse(savedValue);

            if (!Array.isArray(parsedValue)) {
                return [];
            }

            return parsedValue.filter((item) => {
                return item && item.productId && item.variantId;
            });
        } catch (error) {
            console.warn("Kyra Wishlist: no se pudo leer localStorage.", error);
            return [];
        }
    }

    function saveWishlist(items) {
        try {
            window.localStorage.setItem(
                STORAGE_KEY,
                JSON.stringify(items)
            );
        } catch (error) {
            console.warn("Kyra Wishlist: no se pudo guardar.", error);
        }

        syncWishlistUI(items);
    }

    function getProductFromButton(button) {
        const dataset = button.dataset;

        return {
            productId: String(dataset.productId || ""),
            variantId: String(dataset.variantId || ""),
            title: dataset.title || "",
            url: dataset.url || "",
            image: dataset.image || "",
            price: Number(dataset.price || 0),
            priceFormatted: stripHtml(
                dataset.priceFormatted || ""
            ),
            compareAtPrice: Number(dataset.compareAtPrice || 0),
            compareAtPriceFormatted: stripHtml(
                dataset.compareAtPriceFormatted || ""
            ),
            variantTitle: dataset.variantTitle || "",
            rating: Number(dataset.rating || 0),
            ratingCount: Number(dataset.ratingCount || 0)
        };
    }

    function isProductSaved(items, productId) {
        return items.some((item) => {
            return String(item.productId) === String(productId);
        });
    }

    function updateWishlistCount(items) {
        document
            .querySelectorAll("[data-kyra-wishlist-count]")
            .forEach((counter) => {
                if (items.length > 0) {
                    counter.textContent = String(items.length);
                    counter.setAttribute("aria-hidden", "false");
                } else {
                    counter.textContent = "";
                    counter.setAttribute("aria-hidden", "true");
                }
            });
    }

    function updateProductButtons(items) {
        document.querySelectorAll(TOGGLE_SELECTOR).forEach((button) => {
            const productId = button.dataset.productId;
            const saved = isProductSaved(items, productId);
            const title = button.dataset.title || "Producto";

            button.classList.toggle("is-active", saved);
            button.setAttribute("aria-pressed", String(saved));

            button.setAttribute(
                "aria-label",
                saved
                    ? `Eliminar ${title} de la lista de deseos`
                    : `Agregar ${title} a la lista de deseos`
            );
        });
    }

    function createRatingMarkup(item) {
        if (!item.rating || item.rating <= 0) {
            return "";
        }

        const normalizedRating = Math.max(
            0,
            Math.min(5, Math.round(item.rating))
        );

        const stars =
            "★".repeat(normalizedRating) +
            "☆".repeat(5 - normalizedRating);

        const ratingCount =
            item.ratingCount > 0
                ? `<span class="kyra-wishlist-card__rating-count">
             (${escapeHtml(item.ratingCount)})
           </span>`
                : "";

        return `
      <div
        class="kyra-wishlist-card__rating"
        aria-label="${escapeHtml(item.rating)} de 5 estrellas"
      >
        <span
          class="kyra-wishlist-card__stars"
          aria-hidden="true"
        >
          ${stars}
        </span>
        ${ratingCount}
      </div>
    `;
    }

    function createWishlistCard(item) {
        const imageMarkup = item.image
            ? `
        <a
          href="${escapeHtml(item.url)}"
          class="kyra-wishlist-card__image-link"
        >
          <img
            src="${escapeHtml(item.image)}"
            alt="${escapeHtml(item.title)}"
            class="kyra-wishlist-card__image"
            loading="lazy"
            width="300"
            height="300"
          >
        </a>
      `
            : `
        <div class="kyra-wishlist-card__placeholder">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z"
              stroke="currentColor"
              stroke-width="1.5"
            />
          </svg>
        </div>
      `;

        const variantMarkup = item.variantTitle
            ? `
        <p class="kyra-wishlist-card__variant">
          ${escapeHtml(item.variantTitle)}
        </p>
      `
            : "";

        const comparePriceMarkup =
            item.compareAtPrice > item.price &&
                item.compareAtPriceFormatted
                ? `
          <span class="kyra-wishlist-card__compare-price">
            ${escapeHtml(stripHtml(item.compareAtPriceFormatted))}
          </span>
        `
                : "";

        return `
      <article
        class="kyra-wishlist-card"
        data-kyra-wishlist-card="${escapeHtml(item.productId)}"
      >
        <div class="kyra-wishlist-card__media">
          ${imageMarkup}

          <button
            type="button"
            class="kyra-wishlist-card__remove"
            data-kyra-wishlist-remove="${escapeHtml(item.productId)}"
            aria-label="Eliminar ${escapeHtml(item.title)} de la lista"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
                fill="currentColor"
              />
            </svg>
          </button>
        </div>

        <div class="kyra-wishlist-card__body">
          <a
            href="${escapeHtml(item.url)}"
            class="kyra-wishlist-card__title"
          >
            ${escapeHtml(item.title)}
          </a>

          ${variantMarkup}
          ${createRatingMarkup(item)}

          <div class="kyra-wishlist-card__prices">
            ${comparePriceMarkup}

            <span class="kyra-wishlist-card__price">
              ${escapeHtml(stripHtml(item.priceFormatted))}
            </span>
          </div>
        </div>
      </article>
    `;
    }

    function renderWishlist(items) {
        const grid = document.querySelector("#KyraWishlistItems");
        const emptyState = document.querySelector("#KyraWishlistEmpty");

        if (!grid || !emptyState) {
            return;
        }

        if (items.length === 0) {
            grid.innerHTML = "";
            grid.hidden = true;
            emptyState.hidden = false;
            return;
        }

        emptyState.hidden = true;
        grid.hidden = false;

        grid.innerHTML = items
            .map((item) => createWishlistCard(item))
            .join("");
    }

    function syncWishlistUI(items = readWishlist()) {
        updateWishlistCount(items);
        updateProductButtons(items);
        renderWishlist(items);

        const addAllBtn = document.querySelector("#KyraWishlistAddAll");
        if (addAllBtn) {
            addAllBtn.disabled = items.length === 0;
        }

        const shareBtn = document.querySelector("#KyraWishlistShare");
        if (shareBtn) {
            shareBtn.disabled = items.length === 0;
        }
    }

    function toggleWishlistProduct(button) {
        const product = getProductFromButton(button);

        if (!product.productId || !product.variantId) {
            console.warn(
                "Kyra Wishlist: el producto no tiene un ID válido.",
                product
            );
            return;
        }

        const items = readWishlist();

        const existingIndex = items.findIndex((item) => {
            return String(item.productId) === String(product.productId);
        });

        const productWasAlreadySaved = existingIndex >= 0;

        if (productWasAlreadySaved) {
            items.splice(existingIndex, 1);
        } else {
            items.unshift(product);
        }

        saveWishlist(items);

        if (!productWasAlreadySaved) {
            window.requestAnimationFrame(() => {
                openDrawer(button);
            });
        }
    }

    function removeWishlistProduct(productId) {
        const items = readWishlist().filter((item) => {
            return String(item.productId) !== String(productId);
        });

        saveWishlist(items);
    }

    function updateDrawerTriggers(isOpen) {
        document
            .querySelectorAll(`${OPEN_SELECTOR}, ${MOBILE_OPEN_SELECTOR}`)
            .forEach((trigger) => {
                trigger.setAttribute("aria-expanded", String(isOpen));
            });
    }

    function openDrawer(trigger) {
        const drawer = getDrawer();

        if (!drawer) {
            console.warn("Kyra Wishlist: no se encontró el drawer.");
            return;
        }

        syncWishlistUI();

        lastActiveElement = trigger || document.activeElement;

        drawer.classList.add("is-open");
        drawer.setAttribute("aria-hidden", "false");

        document.body.classList.add("kyra-wishlist-open");

        updateDrawerTriggers(true);

        window.requestAnimationFrame(() => {
            drawer
                .querySelector(".kyra-wishlist__close")
                ?.focus();
        });
    }

    function closeDrawer() {
        const drawer = getDrawer();

        if (!drawer || !drawer.classList.contains("is-open")) {
            return;
        }

        drawer.classList.remove("is-open");
        drawer.setAttribute("aria-hidden", "true");

        document.body.classList.remove("kyra-wishlist-open");

        updateDrawerTriggers(false);

        if (
            lastActiveElement &&
            typeof lastActiveElement.focus === "function"
        ) {
            lastActiveElement.focus();
        }

        lastActiveElement = null;
    }

    function openFromMobileMenu(button) {
        const mobileMenuDetails = document.querySelector(
            "#Details-menu-drawer-container"
        );

        const mobileMenuSummary = mobileMenuDetails?.querySelector(
            ":scope > summary"
        );

        if (
            mobileMenuDetails?.hasAttribute("open") &&
            mobileMenuSummary
        ) {
            mobileMenuSummary.click();

            window.setTimeout(() => {
                openDrawer(button);
            }, 280);

            return;
        }

        openDrawer(button);
    }

    document.addEventListener(
        "click",
        (event) => {
            const target =
                event.target instanceof Element
                    ? event.target
                    : null;

            if (!target) {
                return;
            }

            const productToggle = target.closest(
                TOGGLE_SELECTOR
            );

            if (productToggle) {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();

                toggleWishlistProduct(productToggle);
                return;
            }

            const removeButton = target.closest(
                REMOVE_SELECTOR
            );

            if (removeButton) {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();

                removeWishlistProduct(
                    removeButton.dataset.kyraWishlistRemove
                );
                return;
            }

            const mobileOpenButton = target.closest(
                MOBILE_OPEN_SELECTOR
            );

            if (mobileOpenButton) {
                event.preventDefault();
                event.stopPropagation();

                openFromMobileMenu(mobileOpenButton);
                return;
            }

            const openButton = target.closest(
                OPEN_SELECTOR
            );

            if (openButton) {
                event.preventDefault();
                event.stopPropagation();

                openDrawer(openButton);
                return;
            }

            const closeButton = target.closest(
                CLOSE_SELECTOR
            );

            if (closeButton) {
                event.preventDefault();
                event.stopPropagation();

                closeDrawer();
                return;
            }

            const addAllButton = target.closest("#KyraWishlistAddAll");

            if (addAllButton) {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();

                const items = readWishlist();
                if (items.length === 0) return;

                const itemsToAdd = items.map(item => ({
                    id: Number(item.variantId),
                    quantity: 1
                }));

                const originalText = addAllButton.textContent;
                addAllButton.textContent = "Agregando...";
                addAllButton.disabled = true;

                const shopifyRoot = window.Shopify?.routes?.root || '/';

                fetch(shopifyRoot + 'cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items: itemsToAdd })
                })
                .then(response => {
                    if (!response.ok) throw new Error('Error en Shopify');
                    return response.json();
                })
                .then(() => {
                    addAllButton.textContent = "¡Agregados!";
                    window.location.href = shopifyRoot + 'cart';
                })
                .catch(error => {
                    console.error('Fallo al agregar:', error);
                    addAllButton.textContent = "Error";
                    setTimeout(() => {
                        addAllButton.textContent = originalText;
                        addAllButton.disabled = false;
                    }, 2000);
                });

                return;
            }

            // Acción del botón Compartir (Limpia emojis del título para evitar errores de codificación)
            const shareButton = target.closest("#KyraWishlistShare");

            if (shareButton) {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();

                const items = readWishlist();
                if (items.length === 0) return;

                let message = "Hola! Te comparto mis favoritos de Kyra Gold:\n\n";
                
                items.forEach((item, index) => {
                    const cleanTitle = cleanProductTitle(item.title);
                    const productUrl = item.url.startsWith("http") ? item.url : `${window.location.origin}${item.url}`;
                    message += `${index + 1}. *${cleanTitle}* - ${item.priceFormatted}\nLink: ${productUrl}\n\n`;
                });

                message += "Me encantan todos! Que opinas?";

                const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
                window.open(whatsappUrl, '_blank', 'noopener,noreferrer');

                return;
            }
        },
        true
    );

    document.addEventListener("keydown", (event) => {
        if (event.key !== "Escape") {
            return;
        }

        if (getDrawer()?.classList.contains("is-open")) {
            closeDrawer();
        }
    });

    function initializeWishlistUI() {
        syncWishlistUI();

        console.info(
            "[Kyra Wishlist] botones encontrados:",
            document.querySelectorAll(TOGGLE_SELECTOR).length
        );
    }

    if (document.readyState === "loading") {
        document.addEventListener(
            "DOMContentLoaded",
            initializeWishlistUI,
            { once: true }
        );
    } else {
        initializeWishlistUI();
    }

    document.addEventListener("shopify:section:load", () => {
        syncWishlistUI();
    });

    window.addEventListener("storage", (event) => {
        if (event.key === STORAGE_KEY) {
            syncWishlistUI();
        }
    });

    window.KyraWishlist = {
        getItems: readWishlist,
        refresh: syncWishlistUI,
        open: openDrawer,
        close: closeDrawer
    };
})();